// extracted by mini-css-extract-plugin
export var searchHeader = "_3l-0";
export var searchHeaderDark = "_3l-1";